import { Tabs as AntdTab, TabsProps as AntdTabProps } from 'antd'
import React from 'react'

interface TabsProps extends AntdTabProps {}

export const Tabs: React.FC<TabsProps> = props => (
  <AntdTab {...props}>{props.children}</AntdTab>
)
